// @mui material components
import Grid from "@mui/material/Grid";

// Argon Dashboard 2 PRO MUI components
import ArgonBox from "component/Argon/ArgonBox";
import ArgonTypography from "component/Argon/ArgonTypography";
import ArgonButton from "component/Argon/ArgonButton";

// Argon Dashboard 2 PRO MUI example components
import PageLayout from "layout/LayoutContainers/PageLayout";

// Argon Dashboard 2 PRO MUI base styles
import typography from "assets/theme/base/typography";

// Images
import bgImage from "assets/images/illustrations/404.svg";

import { useNavigate } from "react-router-dom";

function Notfound() {
  const navigate = useNavigate();
  const { d1, d3, d4, d5 } = typography;

  return (
    <PageLayout white>
      <ArgonBox
        minHeight="100vh"
        sx={{
          display: "grid",
          placeItems: "center",
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "50%",
        }}
      >
        <Grid container justifyContent="center">
          <Grid item xs={12} md={7} lg={6} sx={{ textAlign: "center", mx: "auto" }}>
            <ArgonBox
              color="info"
              fontWeight="bold"
              fontSize={{ xs: d5.fontSize, sm: d4.fontSize, md: d3.fontSize, lg: d1.fontSize }}
              lineHeight={1.2}
              mb={2}
            >
              Error 404
            </ArgonBox>
            <ArgonTypography variant="h2" color="dark" fontWeight="bold">
              Erm. Page not found
            </ArgonTypography>
            <ArgonTypography variant="body1" color="text">
              We suggest you to go to the homepage while we solve this issue.
            </ArgonTypography>
            <ArgonButton
              onClick={() => navigate('/')}
              variant="gradient" color="dark" sx={{ mt: 5 }}>
              Go to Homepage
            </ArgonButton>
          </Grid>
        </Grid>
      </ArgonBox>
    </PageLayout>
  );
}

export default Notfound;
